module.exports = __webpack_public_path__ + "static/media/born-to-die.9893353f.jpg";